var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 4,
    fill: "#FFFBEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.86 12.573L11.213 22a1.332 1.332 0 001.14 2h11.293a1.332 1.332 0 001.14-2l-5.646-9.427a1.333 1.333 0 00-2.28 0v0zM18 16v2.667M18 21.333h.007",
    stroke: "#D97706",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default __webpack_public_path__ + "static/media/order_warning.acab7be3.svg";
export { SvgOrderWarning as ReactComponent };